import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import logo from "../../assets/icons/mocionLogo.svg";
import Button from "../../components/global/Button";
import { useGetAllClubsByNameQuery } from "../../lib/redux/services/sections/Clubs";
import { useEffect } from "react";
const AddOrganization = () => {
  const { data: clubs, refetch } = useGetAllClubsByNameQuery({});
  useEffect(() => {
    localStorage.setItem("clubId", JSON.stringify(clubs?.data[0].id));
    localStorage.setItem("clubs", JSON.stringify(clubs?.data));
  }, [clubs]);

  return (
    <AuthLayout width="w-[600px]">
      <div className="  flex flex-col gap-8 px-12 ">
        <div className="flex flex-col justify-center items-center gap-5 text-center ">
          <img loading="lazy" width={200} height={200} src={logo} alt="mocion-logo" />
          <PageTitle title="add Organization" />
          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-2">
            you can add your Organization
            <br /> information
          </p>
          <div className="mt-6 flex flex-col items-center justify-center gap-6  w-full">
            <Button
              customeStyle="bg-primary text-white   w-full rounded-full text-lg py-4 "
              href="/auth/add-organization2"
              text="Add Organization"
              width="max-w-[400px] w-full"
            />

            <Button
              customeStyle="bg-white text-red-500  w-full rounded-full  text-lg py-4  "
              href="/home"
              text="Home"
              width="max-w-[400px] w-full"
            />
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default AddOrganization;
